export function removeHeadersKyHook(request: Request, options) {
  if (options.removeKyHeaders) {
    request.headers.delete('X-Ky-Instance');
    request.headers.delete('X-Requested-With');
    options.headers.delete('X-Ky-Instance');
    options.headers.delete('X-Requested-With');
  }
}
